












































import { Vue, Component, Prop } from "vue-property-decorator";
import JobOfferCreate from "../Create/JobOfferCreate.vue";
import JobOfferIstitutoCreate from "@/components/Create/JobOfferIstitutoCreate.vue";
import UserCreate from "../Create/UserCreate.vue";
import ColloquioCVCreate from "../Create/ColloquioCVCreate.vue";
// import RichiestaTirocinanti from "../Create/RichiestaTirocinanti.vue";
import ReportVisitaCreate from "../Create/ReportVisitaCreate.vue";
import AttivitaCreate from "../Create/AttivitaCreate.vue";
import { bus } from "../../main";
import PreferenzaWorkshopCreate from "../Create/PreferenzaWorkshopCreate.vue";
import AllievoCreate from "../Create/AllievoCreate.vue";
import ContattoAziendaCreate from "../Create/ContattoAziendaCreate.vue";
import PreferenzaColloquioCreate from "../Create/PreferenzaColloquioCreate.vue";
import GiornoFogliFirmeCreate from "../Create/GiornoFogliFirmeCreate.vue";
import IspezioneCreate from "../Create/IspezioneCreate.vue"
import NotaAziendaCreate from "@/components/Create/NotaAziendaCreate.vue";
import AbbinamentoAlternanzaCreate from "../Create/AbbinamentoAlternanzaCreate.vue";
import ApprendistatoCreate from "@/components/Create/ApprendistatoCreate.vue";

@Component({
    components: {
        JobOfferCreate,
        JobOfferIstitutoCreate,
        UserCreate,
        ColloquioCVCreate,
        ReportVisitaCreate,
        AttivitaCreate,
        PreferenzaWorkshopCreate,
        AllievoCreate,
        ContattoAziendaCreate,
        PreferenzaColloquioCreate,
        GiornoFogliFirmeCreate,
        IspezioneCreate,
        NotaAziendaCreate,
        AbbinamentoAlternanzaCreate,
        ApprendistatoCreate,
        // RichiestaTirocinanti
    }
})
export default class CreateDialog extends Vue {
    @Prop() params!: object;
    @Prop() activityType!: string;
    @Prop() idRichiesta!: number;
    @Prop() infoTirocinio!: any;
    @Prop() checkInfo!: any;
    @Prop() idAzienda!: number;
    @Prop() idIstituto!: number;
    @Prop() infoAzienda!: any;
    @Prop() info!: any;
    private dialog: boolean;

    constructor() {
        super();
        this.dialog = false;
    }

    created() {
        bus.$on("closeCreateDialog", () => {
            this.dialog = false;
        });
    }
}
